<template>
    <TrfSimpleModal
        titulo="Edição tarefa(s)"
        btnSaveName="Confirmar"
        :isAtivo="isAberto"
        :isScrollPersonalizado="true"
        @close="close"
    >
        <TrfCardInfo
            mensagem='As alterações também serão aplicadas às recorrências das tarefas que ainda estão em aberto.'
        />

        <div
            class="column is-9-desktop is-12-mobile"
            :style="customStyle"
        >
            <label v-if="tipoEdicao === 'departamento'">Novo departamento</label>
            <label v-else-if="tipoEdicao === 'responsavel'">Novo responsável</label>
            
            <Multiselect
                v-if="tipoEdicao === 'departamento'"
                id="select-departamento-modal-edicao-tarefas-lote"
                v-e2e="'select-departamento-modal-edicao-tarefas-lote'"
                v-model="novoDepartamentoId"
                class="multiselect-econtador"
                placeholder="Selecione o novo departamento da tarefa"
                noResultsText="Departamento não encontrado"
                noOptionsText="Nenhum departamento encontrado"
                :searchable="true"
                :options="departamentos"
                :canClear="false"
                @change="changeDepartamento"
                @open="() => isMultiselectOpen = true"
                @close="() => isMultiselectOpen = false"
            />
            
            <Multiselect
                v-else-if="tipoEdicao === 'responsavel'"
                id="select-responsavel-modal-edicao-tarefas-lote"
                v-e2e="'select-responsavel-modal-edicao-tarefas-lote'"
                v-model="novoResponsavelId"
                class="multiselect-econtador"
                placeholder="Selecione um novo responsável pela(s) tarefa(s)"
                noResultsText="Responsável não encontrado"
                noOptionsText="Nenhum responsável encontrado"
                :searchable="true"
                :options="responsaveisComOpcaoSemResponsavel"
                :canClear="false"
                @change="changeResponsavel"
                @open="() => isMultiselectOpen = true"
                @close="() => isMultiselectOpen = false"
            />
        </div>
        
        <template v-slot:slot-footer>
            <button
                class="button is-primary"                
                type="submit"
                id="btn-salvar-edicao-tarefas-lote"
                v-e2e="'btn-salvar-edicao-tarefas-lote'"
                :class="{ 'is-loading': this.isLoading }"
                :disabled="disabled.save"
                @click="save"
            >
                Confirmar
            </button>
            <button 
                class="button"
                id="btn-cancelar-edicao-tarefas-lote"
                v-e2e="'btn-cancelar-edicao-tarefas-lote'"
                @click="close" 
            >
                Cancelar
            </button>
        </template>
    </TrfSimpleModal>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
    name: 'ModalEdicaoTarefasEmLote',
    components: {
        TrfSimpleModal: defineAsyncComponent(() => import('../../../../components/Modal/TrfSimpleModal')),
        Multiselect: defineAsyncComponent(() => import('@vueform/multiselect')),
        TrfCardInfo: defineAsyncComponent(() => import('../../../../components/CardInfo'))
    },
    emits: [
        'close',
        'save'
    ],
    props: {
        isAberto: {
            type: Boolean,
            default: true
        },
        departamentos: {
            type: Array,
            default: () => []
        },
        responsaveis: {
            type: Array,
            default: () => []
        },
        tipoEdicao: {
            type: String,
            default: 'departamento'
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        responsavelSelecionado: {
            type: [String, Number],
            default: null
        }
    },
    data() {
        return {
            isMultiselectOpen: false,
            novoDepartamentoId: null,
            novoResponsavelId: null,
            disabled: {
                save: true
            }
        }
    },
    watch: {
        responsavelSelecionado: {
            handler(newValue) {
                if(this.isAberto && this.tipoEdicao === 'responsavel' && newValue !== null && newValue !== undefined) {
                    this.novoResponsavelId = newValue;
                    this.disabled.save = false;
                }
            },
            immediate: true
        }
    },
    computed: {
      customStyle() {
        if(!this.isMultiselectOpen) return {};
        const opcoes = this.tipoEdicao === 'departamento' ? this.departamentos : this.responsaveisComOpcaoSemResponsavel;
        const tamanho = Math.min(opcoes.length, 5);
        const pixels = 135 + (tamanho * 20);
        return {
            "min-height": `${pixels}px`
        }
      },
      responsaveisComOpcaoSemResponsavel() {
        return [
          { value: 'SEM_RESPONSAVEL', label: 'Sem responsável' },
          ...this.responsaveis
        ];
      }
    },
    methods: {
        close() {
            this.novoDepartamentoId = null;
            this.novoResponsavelId = null;
            this.disabled.save = true;
            this.$emit('close');
        },
        save() {
            if(this.isLoading) return;

            const payload = {};
            if(this.tipoEdicao === 'departamento') {
                payload.novoDepartamentoId = this.novoDepartamentoId;
            } else if(this.tipoEdicao === 'responsavel') {
                payload.novoResponsavelId = this.novoResponsavelId;
            }

            this.$emit('save', payload);
        },
        changeDepartamento(value) {
            this.novoDepartamentoId = value;
            this.disabled.save = false;
        },
        changeResponsavel(value) {
            this.novoResponsavelId = value;
            this.disabled.save = !value;
        }
    }
}
</script>